<h3>Nachgefragte Rezepte:</h3>
<p>Statistik von Google Analytics vom {{ statsDate() }}:</p>

<table class="table-reactive">
  <tbody>
    <tr>
      <th></th>
      <th>Rezept</th>
      <th>Klicks</th>
      <th>%</th>
    </tr>

    <ng-container>
      @for(recipe of stats(); track $index) {
      <tr>
        <td>{{ $index + 1 }}</td>
        <td>
          <a href="{{ recipe.url }}" target="_blank" rel="noopener noreferrer">{{ recipe.recipeName }}</a>
        </td>
        <td>{{ recipe.views }}</td>
        <td>{{ recipe.views / totalViews() | percent }}</td>
      </tr>
    }
    </ng-container>
  </tbody>
</table>

<!-- Count: {{totalViews()}} -->
